import React, { useEffect, useState } from 'react';
import {Link} from 'gatsby'
import Modal from "react-bootstrap/Modal"

import RegisterYourInterest from "@Components/forms/register-your-interest"
import { People_Email } from "../../queries/common_use_query"

const NewHomesLinks = ({hit, pro_url}) => {

    const [show, setShow] = useState(false)
    const [formType, setFormType] = useState('')
    const[negoDet, setNegoDet] = useState();
    const { loading, error, data } = People_Email(hit?.negotiator_details?.email || hit?.negotiator_details?.Email)

    const handleClose = () => setShow(false)
    const handleShow = (form_type) => {
        setShow(true)
        setFormType(form_type)
    }

    useEffect(()=>{
        data?.teams?.length > 0 && setNegoDet(data?.teams[0])
    }, [data])

	return(
        <>
            <div className="link-wrap">
                <a href="javascript:;" onClick={() => handleShow("register_your_interest")}>
                    Register Your Interest
                    <i className="icon-arrow"></i>
                </a>
            </div>
            
            {negoDet?.Phone && 
            <div className="link-wrap">
                <a href={`tel:${negoDet?.Phone}`}>
                    <i className="icon-phone"></i>
                    {negoDet?.Phone}
                </a>
            </div>
            }

            <Modal
                show={show}
                centered={true}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                dialogClassName="modal-90w modal-form modal-form-buy-sell-rent reviewPopup"
                >
                <>
                {formType === "register_your_interest" && <>
                    <Modal.Header closeButton className="contact-close-btn">
                    <Modal.Title className="w-100">
                        Register Your Interest
                    </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="form">
                        <RegisterYourInterest toemail={negoDet?.Email} propertyData={hit} pro_url={pro_url} />
                    </Modal.Body>
                    </>
                }
                </>
            </Modal>

        </>
    )
}

export default NewHomesLinks